import { Data } from 'signup-constants/signupData/Data';
import ReactDOMServer from 'react-dom/server';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DefaultSignature = signupData => {
  const FirstName = signupData[Data.FirstName];
  const LastName = signupData[Data.LastName];
  const Email = signupData[Data.Email];
  const CompanyName = signupData[Data.CompanyName];
  const CompanyDomain = signupData[Data.CompanyDomain];
  const defaultStyle = {
    fontSize: 'medium',
    fontFamily: 'Arial'
  };
  const tdTopAlignStyle = {
    verticalAlign: 'top'
  };
  const tdMiddleAlignStyle = {
    verticalAlign: 'middle',
    height: '25px'
  };
  const tdBottomAlignStyle = {
    verticalAlign: 'bottom'
  };
  const headerStyle = {
    margin: '0px',
    fontSize: '18px',
    color: 'rgb(0, 0, 0)',
    fontWeight: 600
  };
  const companyStyle = {
    margin: '0px',
    color: 'rgb(0, 0, 0)',
    fontSize: '14px',
    lineHeight: '22px'
  };
  const hrStyle = {
    width: '100%',
    borderBottom: '1px solid rgb(248, 98, 149)',
    borderLeft: 'none',
    display: 'block'
  };
  const imageStyle = {
    display: 'block',
    backgroundColor: 'rgb(248, 98, 149)'
  };
  const emailStyle = {
    textDecoration: 'none',
    color: 'rgb(0, 0, 0)',
    fontSize: '12px'
  };
  const signature = /*#__PURE__*/_jsx("table", {
    border: 0,
    cellPadding: "0",
    cellSpacing: "0",
    style: defaultStyle,
    children: /*#__PURE__*/_jsxs("tbody", {
      children: [/*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsx("table", {
            border: 0,
            cellPadding: "0",
            cellSpacing: "0",
            style: defaultStyle,
            children: /*#__PURE__*/_jsx("tbody", {
              children: /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsxs("td", {
                  style: tdTopAlignStyle,
                  children: [/*#__PURE__*/_jsxs("h2", {
                    color: "#000000",
                    style: headerStyle,
                    children: [/*#__PURE__*/_jsx("span", {
                      children: FirstName
                    }), /*#__PURE__*/_jsx("span", {
                      children: "\xA0"
                    }), /*#__PURE__*/_jsx("span", {
                      children: LastName
                    })]
                  }), /*#__PURE__*/_jsx("p", {
                    color: "#000000",
                    style: companyStyle,
                    children: /*#__PURE__*/_jsx("span", {
                      children: CompanyName
                    })
                  }), /*#__PURE__*/_jsx("table", {
                    border: 0,
                    cellPadding: "0",
                    cellSpacing: "0",
                    style: Object.assign({}, defaultStyle, {
                      width: '100%'
                    }),
                    children: /*#__PURE__*/_jsxs("tbody", {
                      children: [/*#__PURE__*/_jsx("tr", {
                        children: /*#__PURE__*/_jsx("td", {
                          height: "30"
                        })
                      }), /*#__PURE__*/_jsx("tr", {
                        children: /*#__PURE__*/_jsx("td", {
                          color: "#f86295",
                          height: 1,
                          style: hrStyle,
                          width: "auto"
                        })
                      }), /*#__PURE__*/_jsx("tr", {
                        children: /*#__PURE__*/_jsx("td", {
                          height: "30"
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsx("table", {
                    border: 0,
                    cellPadding: "0",
                    cellSpacing: "0",
                    style: defaultStyle,
                    children: /*#__PURE__*/_jsxs("tbody", {
                      children: [/*#__PURE__*/_jsxs("tr", {
                        style: tdMiddleAlignStyle,
                        children: [/*#__PURE__*/_jsx("td", {
                          style: tdMiddleAlignStyle,
                          width: "30",
                          children: /*#__PURE__*/_jsx("table", {
                            border: 0,
                            cellPadding: "0",
                            cellSpacing: "0",
                            style: defaultStyle,
                            children: /*#__PURE__*/_jsx("tbody", {
                              children: /*#__PURE__*/_jsx("tr", {
                                children: /*#__PURE__*/_jsx("td", {
                                  style: tdBottomAlignStyle,
                                  children: /*#__PURE__*/_jsx("span", {
                                    color: "#f86295",
                                    style: imageStyle,
                                    children: /*#__PURE__*/_jsx("img", {
                                      alt: "emailAddress",
                                      color: "#f86295",
                                      src: "https://cdn2.hubspot.net/hubfs/53/tools/email-signature-generator/icons/email-icon-2x.png",
                                      style: imageStyle,
                                      width: "13"
                                    })
                                  })
                                })
                              })
                            })
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx("a", {
                            color: "#000000",
                            href: "mailto:{{ Email }}",
                            style: emailStyle,
                            children: /*#__PURE__*/_jsx("span", {
                              children: Email
                            })
                          })
                        })]
                      }), /*#__PURE__*/_jsxs("tr", {
                        style: tdMiddleAlignStyle,
                        children: [/*#__PURE__*/_jsx("td", {
                          style: tdMiddleAlignStyle,
                          width: 30,
                          children: /*#__PURE__*/_jsx("table", {
                            border: 0,
                            cellPadding: "0",
                            cellSpacing: "0",
                            style: defaultStyle,
                            children: /*#__PURE__*/_jsx("tbody", {
                              children: /*#__PURE__*/_jsx("tr", {
                                children: /*#__PURE__*/_jsx("td", {
                                  style: tdBottomAlignStyle,
                                  children: /*#__PURE__*/_jsx("span", {
                                    color: "#f86295",
                                    style: imageStyle,
                                    children: /*#__PURE__*/_jsx("img", {
                                      alt: "website",
                                      color: "#f86295",
                                      src: "https://cdn2.hubspot.net/hubfs/53/tools/email-signature-generator/icons/link-icon-2x.png",
                                      style: imageStyle,
                                      width: "13"
                                    })
                                  })
                                })
                              })
                            })
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx("a", {
                            color: "#000000",
                            href: CompanyDomain,
                            style: emailStyle,
                            children: /*#__PURE__*/_jsx("span", {
                              children: CompanyDomain
                            })
                          })
                        })]
                      })]
                    })
                  })]
                }), /*#__PURE__*/_jsx("td", {
                  width: "45",
                  children: /*#__PURE__*/_jsx("div", {})
                })]
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          height: "30"
        })
      })]
    })
  });
  return ReactDOMServer.renderToString(signature);
};